export enum WelcomeGiftTypes {
  points = 'points',
  discount = 'discount'
}
